var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.658,
    height: 52.898,
    viewBox: "0 0 52.658 52.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M48.988,11.688A26.223,26.223,0,0,0,7.72,43.314L4,56.9l13.9-3.651a26.237,26.237,0,0,0,12.53,3.2h.009A26.223,26.223,0,0,0,48.988,11.688ZM30.441,52.013h-.009a21.789,21.789,0,0,1-11.09-3.034l-.8-.471-8.254,2.16,2.2-8.039-.514-.823A21.791,21.791,0,1,1,30.441,52.013ZM42.388,35.694c-.651-.326-3.874-1.911-4.474-2.126s-1.037-.326-1.474.326-1.688,2.134-2.074,2.571-.763.489-1.414.163a17.73,17.73,0,0,1-5.271-3.257,19.609,19.609,0,0,1-3.643-4.534c-.386-.66-.043-1.011.283-1.337.3-.291.66-.763.986-1.148a4.559,4.559,0,0,0,.66-1.088,1.221,1.221,0,0,0-.06-1.148c-.163-.326-1.474-3.557-2.023-4.868-.531-1.277-1.071-1.1-1.474-1.123-.377-.017-.814-.017-1.251-.017a2.4,2.4,0,0,0-1.748.823,7.329,7.329,0,0,0-2.288,5.46c0,3.223,2.348,6.342,2.674,6.779s4.62,7.045,11.193,9.882a36.36,36.36,0,0,0,3.728,1.38,9.111,9.111,0,0,0,4.131.266c1.26-.189,3.874-1.586,4.422-3.12a5.506,5.506,0,0,0,.377-3.111C43.485,36.192,43.048,36.029,42.388,35.694Z",
    transform: "translate(-4 -4)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.16e6e5df2ad5ff99167bea337c803a08.svg";
export { ForwardRef as ReactComponent };